import { render, staticRenderFns } from "./ContratosAbertos.vue?vue&type=template&id=243f0e85"
import script from "./ContratosAbertos.vue?vue&type=script&lang=js"
export * from "./ContratosAbertos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports